import "./Intro.scss";
import DiagArrow from "../../assets/icons/diag-arrow.svg";

const Intro = ({}) => {
  return (
    <div className="intro-paper-root">
      <div className="intro-bg" />
      <div className="intro-bg-image" />
      <div className="container intro-z9">
        <span>
          <span className="title">
            Verified Achievements, on
            <span className="title__edu-chain"> EDU Chain</span>
          </span>
        </span>
        <span className="subtitle w-530 mt-30 mb-30">
          Transform your educational journey into verifiable Web3 credentials
          that are secure, decentralized, and recognized across the Open Campus
          ecosystem.
        </span>
        <div className="flex items-center">
          <a href="https://id.opencampus.xyz/auth" className="btn-blue">
            Get started now
            <img src={DiagArrow} alt={"diag"} className={"ml-10"} />
          </a>
        </div>
      </div>
      <div className="container intro-z2">
        <div className="intro-content-box">
          <span className={"intro-content-box__title"}>
            What are OC Achievements?
          </span>
          <span className={"intro-content-box__subtitle"}>
            OC Achievements is a blockchain-powered credentialing system that
            allows learners to earn, verify, and showcase their educational
            accomplishments on EDU Chain. Each achievement is securely recorded
            on-chain, giving users full control over their learning records and
            enabling seamless recognition across the Open Campus ecosystem.
          </span>
        </div>
      </div>
    </div>
  );
};

export default Intro;
